/* Secondipity saved items: product handles only, stored on this browser. */
(() => {
  'use strict';
  const key = 'sdp_wishlist_v1';
  const maxItems = 100;
  const dialog = document.getElementById('sdp-saved-items');
  if (!dialog) return;
  const list = dialog.querySelector('[data-saved-list]');
  const status = document.querySelector('[data-saved-status]');
  const cache = new Map();
  let handles = [];
  let generation = 0;
  let opener = null;
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  function read() {
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(parsed) ? [...new Set(parsed.filter(valid))].slice(0, maxItems) : [];
    } catch (_) { return []; }
  }
  let statusTimer;
  function announce(message) { if (!status) return; clearTimeout(statusTimer); status.textContent = message; statusTimer=setTimeout(()=>{status.textContent='';},5000); }
  function sync() {
    document.querySelectorAll('[data-sdp-save]').forEach(button => {
      const saved = handles.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(saved));
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + (button.dataset.productTitle || 'item') + (saved ? ' from saved items' : ' to saved items'));
      const label = button.querySelector('[data-save-label]');
      const nextLabel = saved ? 'Saved' : 'Save item';
      if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
    });
    document.querySelectorAll('[data-saved-count]').forEach(count => { if (count.textContent !== String(handles.length)) count.textContent = String(handles.length); count.hidden = handles.length === 0; });
  }
  function write(next, message) {
    try {
      localStorage.setItem(key, JSON.stringify(next));
      handles = next;
      sync();
      announce(message);
      return true;
    } catch (_) { announce('Your browser could not save this item. Check its storage settings and try again.'); return false; }
  }
  function node(tag, text, className) {
    const element = document.createElement(tag);
    if (text) element.textContent = text;
    if (className) element.className = className;
    return element;
  }
  const root = dialog.dataset.root || '/';
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  function remove(handle) {
    if (write(handles.filter(value => value !== handle), 'Item removed from saved items.')) render();
  }
  async function getProduct(handle) {
    const prior = cache.get(handle);
    if (prior && Date.now() - prior.time < 60000) return prior.product;
    const response = await fetch(productUrl(handle) + '.js', {credentials:'same-origin', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json();
    cache.set(handle, {time:Date.now(),product});
    return product;
  }
  function card(handle, product) {
    const item = node('article', '', 'sdp-saved-card');
    const link = node('a', '', 'sdp-saved-card__link');
    link.href = productUrl(handle);
    if (product && product.featured_image) {
      try {
        const url = new URL(product.featured_image, location.origin);
        if (url.protocol === 'https:' || url.protocol === 'http:') {
          const image = node('img'); image.src = url.href; image.alt = product.title || 'Saved item';
          image.width = 180; image.height = 180; image.loading = 'lazy'; link.append(image);
        }
      } catch (_) { /* A malformed image does not remove the saved product. */ }
    }
    link.append(node('h3', product ? product.title : 'This item is currently unavailable'));
    item.append(link);
    if (product) {
      try { item.append(node('p', new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:dialog.dataset.currency || 'USD'}).format(product.price / 100))); }
      catch (_) { item.append(node('p', 'View current price on the product page.')); }
      item.append(node('p', product.available ? 'Available — view item' : 'Sold out', 'sdp-saved-availability'));
    } else item.append(node('p', 'It may have been removed or could not be loaded. Your saved item is retained.'));
    const button = node('button', 'Remove', 'sdp-saved-remove'); button.type = 'button';
    button.setAttribute('aria-label', 'Remove ' + (product ? product.title : 'unavailable item') + ' from saved items');
    button.addEventListener('click', () => remove(handle)); item.append(button); return item;
  }
  async function render() {
    const token = ++generation;
    const current = [...handles];
    list.replaceChildren();
    if (!current.length) { list.append(node('p', 'Your saved items will appear here. Tap the heart on any product to save it.')); return; }
    const slots = current.map(() => { const slot = node('div', 'Loading saved item…', 'sdp-saved-loading'); list.append(slot); return slot; });
    let cursor = 0;
    async function worker() {
      while (cursor < current.length && token === generation && dialog.open) {
        const index = cursor++, handle = current[index]; let product = null;
        try { product = await getProduct(handle); } catch (_) { /* Show a removable unavailable item. */ }
        if (token !== generation || !dialog.open) return;
        slots[index].replaceWith(card(handle,product));
      }
    }
    await Promise.all(Array.from({length:Math.min(4,current.length)}, worker));
  }
  function open(button) {
    opener = button; handles = read(); sync();
    if (typeof dialog.showModal !== 'function') { announce('Saved items need a newer browser. Your saved items are still stored here.'); return; }
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('sdp-saved-open'); render();
  }
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-sdp-save]');
    if (save) {
      event.preventDefault(); const handle = save.dataset.productHandle; if (!valid(handle)) return;
      handles = read(); const exists = handles.includes(handle);
      if (!exists && handles.length >= maxItems) { announce('You have saved 100 items. Remove an item before adding another.'); return; }
      write(exists ? handles.filter(value => value !== handle) : [handle,...handles], exists ? 'Item removed from saved items.' : 'Item saved on this browser.');
      return;
    }
    const trigger = event.target.closest('[data-open-saved]'); if (trigger) { event.preventDefault(); open(trigger); }
    if (event.target.closest('[data-close-saved]')) dialog.close();
  });
  dialog.addEventListener('close', () => { ++generation; document.documentElement.classList.remove('sdp-saved-open'); if (opener && opener.isConnected) opener.focus(); });
  window.addEventListener('storage', event => { if (event.key === key) { handles = read(); sync(); if (dialog.open) render(); } });
  new MutationObserver(records => { if(records.some(record => Array.from(record.addedNodes).some(n=>n.nodeType===1&&(n.matches('[data-sdp-save]')||n.querySelector('[data-sdp-save]'))))) sync(); }).observe(document.getElementById('main-content') || document.body,{childList:true,subtree:true});
  handles = read(); sync();
})();
